import { Outlet } from "react-router";
import {
  LogoutButton,
  NavbarDropdown,
  NavbarLink,
  NavbarStaticText,
} from "./NavComponents";
import {
  gallowsPublishAtom,
  tourPublishAtom,
} from "../components/Publishing/atoms";
import { useEffect, useState } from "react";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import {
  hostDataAtom,
  IModelData,
  loginStatusAtom,
  modelDataAtom,
} from "../atoms";
import apiAgent from "../api/apiAgent";
import { transformModelSchema } from "../utils";
import { Loader } from "../components/Loader";
import { tMsg } from "../components/ToastNotifications";
import { getPublishStates } from "../components/Publishing/utils";
import { NavPublishSection } from "../components/Publishing";

/**
 * Modify this fo adjust menu items
 * @returns Navbar Menu
 */

const NavbarLayout = () => {
  const setModelData = useSetAtom(modelDataAtom);
  const setHostData = useSetAtom(hostDataAtom);
  const setTourPublished = useSetAtom(tourPublishAtom);
  const setGallowsPublished = useSetAtom(gallowsPublishAtom);
  const [loginStatus, setLoginStatus] = useAtom(loginStatusAtom);
  const [modelsLoaded, setModelsLoaded] = useState<boolean>(false);
  const [hostDataLoaded, setHostDataLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (loginStatus === true) {
      if (!modelsLoaded) fetchModelData();
      if (!hostDataLoaded) fetchHostData();
      getPublishStates("featureNodes", setTourPublished);
      getPublishStates("gallows", setGallowsPublished);
    }
  }, [loginStatus]);

  const fetchHostData = async () => {
    try {
      const response = await apiAgent.Hosting.get();
      // console.log(hostResponse);
      if (response.status === 200) {
        // console.log("Host data loaded");
        setHostData(response.data);
        setHostDataLoaded(true);
      } else if (response.status === 401) {
        setLoginStatus(false);
      }
    } catch (err) {
      console.log("Could not set host data", err);
    }
  };

  const fetchModelData = async () => {
    try {
      const response = await apiAgent.Models.getAll();
      // console.log(response.data);
      if (response.status === 200) {
        // Since the CMS also allows managing "users" (a system model), add that here too
        const userModel: IModelData = response.data.system_models.find(
          (sm: any) => sm.name === "users",
        );
        const allModels: IModelData[] = [userModel, ...response.data.models];

        const modelData = transformModelSchema(allModels);
        // console.log("Model data loaded:", modelData);
        setModelData(modelData);
        setModelsLoaded(true);
      } else if (response.status === 401) {
        setLoginStatus(false);
      }
    } catch (err) {
      console.log(err);
      console.log("Could not load modelData");
    }
  };

  return (
    <div className="w-full h-full min-w-[60rem] flex bg-sidebarBg">
      <div className="w-[16rem] flex flex-col">
        <div className="p-8 w-full flex justify-center">
          <img src="/assets/odg_cms_logo_180px.png" className="w-24" />
        </div>
        <NavbarLink to="/">Home</NavbarLink>
        <NavbarDropdown label="Tour Website">
          <NavbarLink to="/m/featurenodes">Map</NavbarLink>
          <NavbarLink to="/m/tags">Filters</NavbarLink>
          <NavbarLink to="/m/resources">Resources</NavbarLink>
          <NavbarLink to="/m/abouts">About</NavbarLink>
          <NavbarLink to="/si/welcomepopup">Welcome Popup</NavbarLink>
          <NavbarStaticText>
            <NavPublishSection appGroup="featureNodes" />
          </NavbarStaticText>
        </NavbarDropdown>
        <NavbarDropdown label="Gallows Interactive">
          <NavbarLink to="/si/screensaver">Screensaver</NavbarLink>
          <NavbarLink to="/m/people">People</NavbarLink>
          <NavbarStaticText>
            <NavPublishSection appGroup="gallows" />
          </NavbarStaticText>
        </NavbarDropdown>
        <div className="w-full flex-grow " />
        <LogoutButton />
      </div>
      <div className="w-[calc(100%-16rem)] h-full bg-white text-black">
        {modelsLoaded ? (
          <Outlet />
        ) : (
          <div className="w-full h-full text-center grid content-center text-grayText">
            <Loader />
            <div className="my-4">loading model data... Please wait</div>
          </div>
        )}
      </div>
    </div>
  );
};

export { NavbarLayout };
